import { redirect } from '@tanstack/react-router'

/**
 * Checks if the user is authenticated by looking for the 'loggedin' cookie
 */
function isAuthenticated(): boolean {
  if (typeof document === 'undefined') return false
  const match = document.cookie.match(/(?:^|;\s*)loggedin=([^;]+)/)
  return !!match && match[1].trim() !== ''
}

/**
 * Creates a beforeLoad hook for protecting routes
 * Redirects unauthenticated users to /login with a ?to= parameter
 * containing the original relative URL
 */
export function createAuthGuard() {
  return async (context: any) => {
    if (!isAuthenticated()) {
      try {
        // Get the current pathname and search/hash from location
        const location = context.location as { pathname: string; search: string; hash: string }
        
        // Construct the full relative URL without the domain
        const originalRoute = `${location.pathname}${location.search}${location.hash}`
        
        // Store the redirect target in sessionStorage as a workaround for search param serialization issues
        if (typeof window !== 'undefined') {
          sessionStorage.setItem('redirectAfterLogin', originalRoute)
        }
        
        // Redirect to login
        throw redirect({
          to: '/login',
        })
      } catch (error) {
        // If it's a redirect, re-throw it
        if (error instanceof Error && error.message.includes('redirect')) {
          throw error
        }
        // Otherwise log and redirect
        console.error('Error in auth guard:', error)
        throw redirect({
          to: '/login',
        })
      }
    }
  }
}
